import { render, staticRenderFns } from "./documents_page.vue?vue&type=template&id=6affe1c0"
import script from "./documents_page.vue?vue&type=script&lang=js"
export * from "./documents_page.vue?vue&type=script&lang=js"
import style0 from "./documents_page.vue?vue&type=style&index=0&id=6affe1c0&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports